import moment from 'moment';

const dataLayer = window.dataLayer || [];

const gtmEvents = {
  activationNoteCreated: 'activationNoteCreated',
  activationInstallationCreated: 'activationInstallationCreated',
};

export default function DevicesActivationsWizardController(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $q,
  $timeout,
  $filter,
  $uibModal,
  installationsService,
  transfersService,
  productService,
  devicesService,
  mapService,
  packagesService,
  installationNoteService,
  securityGroupsService,
  equipmentRepository,
  gettextCatalog,
  syncRunHoursService,
  tagsService,
  appSettings,
  usersService,
) {
  'ngInject';

  const vm = this;
  let mapCreated = false;
  const myIcon = L.icon({
    iconUrl: '/Home/Content/svg/pin.png',
    iconSize: [20, 45],
    iconAnchor: [22, 94],
  });
  const changeset = {
    op: 'add',
  };

  let hardware = '';
  let canSyncRunHours = false;

  $scope.steps = [
    'activate',
    'communicate',
    'connect',
    'status',
    'sync',
    'location',
    'confirm',
    'data',
    'notes',
  ];
  $scope.step = $scope.steps[0];
  $scope.product = {};
  $scope.model = {};
  $scope.equipment = {
    name: '',
    make: '',
    model: '',
    package: '',
    module: [],
    year: '',
    vin: '',
    transferKey: [],
  };
  $scope.security = {
    group: '',
  };
  $scope.availableSecurityGroups = [];
  $scope.error = null;
  $scope.products = [];
  $scope.installations = [];
  $scope.packages = [];
  $scope.modules = [];
  $scope.transferKeys = [];
  $scope.availableProducts = [];
  $scope.activationSuccessFlag = false;
  $scope.activationSuccessMsg = gettextCatalog.getString('This device was successfully activated.');
  $scope.transferSuccessFlag = false;
  $scope.transferSuccessMsg = gettextCatalog.getString(
    'This device was successfully activated and transferred.',
  );
  $scope.showActivationForm = false;
  $scope.canTransfer = false;
  $scope.hasPkgModules = false;
  $scope.selectedModules = [];
  $scope.selectedPackageModules = [];
  $scope.templatesAvailable = true;
  $scope.lastCommunication = '';
  $scope.hasSecurityGroups = false;
  $scope.isSGOptional = false;
  $scope.reloadingLastComm = false;
  $scope.disable = {
    next: false,
  };
  $scope.checkBox = {
    isChecked: false,
  };
  $scope.isConnected = false;
  $scope.communicationActions = 'unconfirmed';
  $scope.showActivationMap = false;
  $scope.loadingLocation = false;
  $scope.gpsLocationModel = 0;
  $scope.gpsLocationAction = 'unconfirmed'; // default action
  $scope.runHours = null;
  $scope.runHoursModel = 0;
  $scope.runHoursAction = 'unconfirmed'; // default action
  $scope.refreshingSeriesData = false;
  $scope.noSeriesData = false;
  $scope.seriesDataMsg = gettextCatalog.getString('Asset Data currently unavailable');
  $scope.equipmentSeries = {
    isLoadingTableData: false,
    lastcomm: $scope.lastCommunication,
    tabularDatapoints: [],
  };
  $scope.wantedSeriesList = [
    'Battery',
    'Run Time',
    'Engine Status',
    'Oil Pressure',
    'Engine Coolant Temperature',
  ];
  $scope.note = {
    text: '',
  };
  $scope.validatingSerialNumber = false;
  $scope.helpContent = {
    helpMe: 'singleActivation',
  };

  $scope.userSelectedTemplatePackage = false;

  /* for tags */
  $scope.tags = [];
  $scope.selectedTags = [];
  $scope.parsedTags = [];
  $scope.values = {};
  $scope.opened = {};
  $scope.datetimedate = {};
  $scope.datetimeBounds = {};
  $scope.minMaxRequired = {};
  $scope.showTag = {};
  $scope.focus = {};
  $scope.dateOptions = {
    'year-format': "'yy'",
    'starting-day': 1,
  };

  // init
  vm.$onInit = () => {
    vm.dateFormat = appSettings.GetDateFormat();
    vm.hasSyncFeature = usersService.hasRequiredFeatures(['assets.run_time_sync']);
  };

  const setTimeHMS = (targetDate, sourceDate) => {
    // Setting targetDate HMS from sourceDate
    targetDate.set({
      hours: sourceDate.getHours(),
      minutes: sourceDate.getMinutes(),
      seconds: sourceDate.getSeconds(),
    });
  };
  // Local Functions
  function getAllProducts() {
    productService
      .getAllProducts()
      .then(function (response) {
        $scope.products = response.data;
        if ($scope.products.length === 0) {
          $scope.templatesAvailable = false;
        }
      })
      .catch(function () {
        $scope.error = gettextCatalog.getString(
          'An error occurred while retrieving template information.',
        );
      });
  }
  getAllProducts();

  function getAllSecurityGroups() {
    securityGroupsService
      .getAllSecurityGroups()
      .then(function (response) {
        const securityGroups = response.data.data;
        const user = $rootScope.currentUser;
        if (user.securityMode === 'Discretionary') {
          if (user.groups.data.length === 1) {
            // When the user's securityMode is set to discretionary and belongs to a single
            // security group, automatically assign the installation to that security group
            // and do not display the security group dropdown on the activation form
            $scope.security.group = user.groups.data[0];
          } else if (user.groups.data.length > 1) {
            for (let i = 0; i !== user.groups.data.length; ++i) {
              // When the user's securityMode is set to discretionary and belongs to multiple
              // security groups, populate the dropdown with a list of the available security
              // groups and show the dropdown on the activation form.
              $scope.availableSecurityGroups.push(user.groups.data[i]);
              $scope.hasSecurityGroups = true;
            }
          } else {
            // $scope.invalidSecuirtyGroupErrorFlag = true;
          }
        } else if (user.securityMode === 'Open') {
          if (securityGroups) {
            for (let i = 0; i !== securityGroups.length; ++i) {
              // When the user's securityMode is set to open populate the dropdown with a list
              // of the available security groups and show the dropdown on the activation form.
              $scope.availableSecurityGroups.push(securityGroups[i]);
            }
            $scope.hasSecurityGroups = true; // show dropdown
            $scope.isSGOptional = true; // sets security group to optional instead of required
          }
        }
      })
      .catch(function () {
        $scope.hasSecurityGroups = false;
        $scope.error = gettextCatalog.getString(
          'An error occurred while retrieving security groups.',
        );
      });
  }
  getAllSecurityGroups();

  $scope.serialNumberChanged = (serialNum) => {
    if (!serialNum) {
      clearForm();
    }
  };

  function getTransferKeys() {
    transfersService
      .getTransferKeys()
      .then(function (response) {
        const { transferKeys } = response.data;
        $scope.transferKeys.push({
          account: gettextCatalog.getString('DO NOT TRANSFER'),
          id: null,
        });
        for (let i = 0; i < transferKeys.length; i++) {
          if (transferKeys[i].permissions.resources !== null) {
            if (transferKeys[i].permissions.resources.indexOf('installations') >= 0) {
              $scope.transferKeys.push({
                account: transferKeys[i].account,
                id: transferKeys[i].key,
              });
            }
          }
        }
        $scope.model.transferKey = $scope.transferKeys[0];
      })
      .catch(function () {
        $scope.error = gettextCatalog.getString(
          'An error occurred while retrieving transfer keys.',
        );
      });
  }

  // The user must have the feature permission to transfer devices
  function canUserTransfer() {
    for (let i = 0; i < $rootScope.currentUser.features.length; i++) {
      if ($rootScope.currentUser.features[i].path.indexOf('devices.transfer') >= 0) {
        $scope.canTransfer = true;
        getTransferKeys();
      }
    }
  }
  canUserTransfer();

  function getTags() {
    equipmentRepository
      .getAllTags()
      .then(function (response) {
        $scope.tags = response.data.data;
        for (let i = 0; i < $scope.tags.length; i++) {
          if ($scope.tags[i].dataType === 'Datetime') {
            if ($scope.tags[i].range.min) {
              $scope.tags[i].range.min = moment($scope.tags[i].range.min).toDate();
            }
            if ($scope.tags[i].range.max) {
              $scope.tags[i].range.max = moment($scope.tags[i].range.max).toDate();
            }
          }
          if (
            $scope.tags[i].key.toLowerCase() === 'make' ||
            $scope.tags[i].key.toLowerCase() === 'model' ||
            $scope.tags[i].key.toLowerCase() === 'model year' ||
            $scope.tags[i].key.toLowerCase() === 'vin'
          ) {
            $scope.tags.splice(i, 1);
            i--;
          }
        }
      })
      .catch(function () {
        $scope.error = gettextCatalog.getString('An error occurred while retrieving attributes.');
      });
  }
  getTags();

  function checkProductsForCompatibility() {
    $scope.availableProducts = [];
    $scope.isTemplateSelected = false;
    for (let i = 0; i !== $scope.packages.length; ++i) {
      for (let c = 0; c !== $scope.products.length; ++c) {
        if ($scope.packages[i].id === $scope.products[c].package.id) {
          $scope.availableProducts.push($scope.products[c]);
        }
      }
    }
    $scope.templatesAvailable = $scope.availableProducts.length > 0;
  }

  function packageAllowsRunHoursSync() {
    const packagesIds = $scope.installation.packages.map((pkg) => pkg.id);
    syncRunHoursService
      .getSyncRunHoursTag(packagesIds)
      .then((tag) => {
        canSyncRunHours = !!tag;
        $scope.installation.syncRunHoursTag = tag;
      })
      .catch(() => {});
  }

  function createMap() {
    if (mapCreated) return;
    mapCreated = true;
    vm.map = mapService.createMapDiv('map');

    // Set an initial default view of the map.  If the device communicates this will be updated when we get to the GPS Location page.
    vm.map.setView([40, -74.5], 3);

    vm.map.scrollWheelZoom.disable();
  }
  createMap();

  // Step 9 - Installation Notes & Complte Activation Wizard
  function createNote() {
    dataLayer.push({
      event: gtmEvents.activationNoteCreated,
      data: {
        installationId: $scope.installationId,
      },
    });

    installationNoteService
      .createNote($scope.installationId, {
        text: $scope.note.text,
      })
      .then(function () {
        $scope.note.text = '';
      })
      .catch(function () {
        $scope.error = gettextCatalog.getString('An error occurred while creating the note.');
      });
  }

  function logUserActions() {
    changeset.values = {
      connected: $scope.communicationActions,
      run_hours: $scope.runHoursAction,
      location: $scope.gpsLocationAction,
    };
    installationNoteService.patchInstallationAttrs($scope.installationId, changeset).then(
      function () {},
      function () {
        $scope.error = gettextCatalog.getString(
          'An error occurred while patching installation attributes.',
        );
      },
    );
  }

  function clearForm() {
    $scope.deviceSerialNumberError = '';
    $scope.model.deviceSerialNumber = null;
    $scope.model.equipmentName = null;
    $scope.model.equipmentMake = null;
    $scope.equipment.make = null;
    $scope.model.equipmentModel = null;
    $scope.equipment.model = null;
    $scope.equipment.package = [];
    $scope.equipment.module = [];
    $scope.model.transferKey = [];
    $scope.model.equipmentModelYear = null;
    $scope.model.equipmentVin = null;
    $scope.isTemplateSelected = false;
    $scope.packages.length = 0;
    $scope.activationForm.$setPristine();
    $scope.activationForm.$setUntouched();
  }

  // traverse through steps[] to change the view
  $scope.next = function () {
    switch ($scope.step) {
      case 'notes':
        $scope.step = $scope.steps[9];
        break;
      case 'data':
        $scope.step = $scope.steps[8];
        $scope.isSeriesData = true;
        break;
      case 'confirm':
        $scope.step = $scope.steps[7];
        break;
      case 'location':
        $scope.step = $scope.steps[6];
        $scope.showActivationMap = false;
        if (canSyncRunHours === false) $scope.next();
        $scope.getLastReportedRunHours();
        $scope.getDataPointValues();
        break;
      case 'sync':
        $scope.step = $scope.steps[5];
        $scope.showActivationMap = true;
        $scope.getInstallationLocation();
        break;
      case 'status':
        $scope.step = $scope.steps[4];
        if (!canSyncRunHours || !vm.hasSyncFeature) $scope.next();
        break;
      case 'connect':
        $scope.step = $scope.steps[3];
        packageAllowsRunHoursSync();
        break;
      case 'communicate':
        $scope.step = $scope.steps[2];
        $scope.activationSuccessFlag = false;
        $scope.getLastComm();
        break;
      case 'activate':
        $scope.step = $scope.steps[1];
        break;
    }
  };

  $scope.isFormValid = function () {
    $scope.activationForm.$setSubmitted();
    if ($scope.activateWithTemplate) {
      if (!$scope.product) return;
    } else if (!$scope.activationForm.package.$modelValue) {
      $scope.activationForm.package.$invalid = true;
      return;
    }

    if ($scope.activationForm.$invalid) {
      if (
        $scope.activationForm.package.$modelValue === undefined ||
        $scope.activationForm.package.$modelValue === null ||
        $scope.activationForm.package.$modelValue === ''
      ) {
        $scope.activationForm.package.$invalid = true;
      }
    } else {
      $scope.submitActivationForm();
    }
  };

  $scope.appendTag = function (tag) {
    $scope.selectedTags.push(tag);
    $scope.values[tag.id] = {
      tag: tag.id,
    };

    if (tag.dataType === 'Date' || tag.dataType === 'Datetime') {
      $scope.opened[tag.id] = false;

      if (tag.freeform) {
        $scope.values[tag.id].value = moment().toDate();

        if (tag.dataType === 'Datetime') {
          $scope.datetimedate[tag.id] = moment($scope.values[tag.id].value.toISOString()).toDate();

          $scope.datetimeBounds[tag.id] = {};
        }
      } else {
        if (tag.range.min) {
          $scope.values[tag.id].value = tag.range.min;

          if (tag.dataType === 'Datetime') {
            $scope.datetimedate[tag.id] = tag.range.min;
            $scope.values[tag.id].minValue = tag.range.min;

            $scope.datetimeBounds[tag.id] = {};
          }
        }
        if (tag.range.max) {
          $scope.values[tag.id].value = tag.range.max;

          if (tag.dataType === 'Datetime') {
            $scope.datetimedate[tag.id] = tag.range.max;
            $scope.values[tag.id].maxValue = tag.range.max;

            $scope.datetimeBounds[tag.id] = {};
          }
        }
      }
    }

    tag.selected = true;
    $scope.newTag = undefined;
    $scope.focus[tag.id] = true;
  };

  $scope.removeTag = function (index) {
    $scope.selectedTags[index].selected = false;
    delete $scope.values[$scope.selectedTags[index].id];
    delete $scope.focus[$scope.selectedTags[index].id];
    $scope.selectedTags.splice(index, 1);
  };

  $scope.filterSelected = function (tag) {
    if (tag.selected) {
      return false;
    }
    return true;
  };

  $scope.roundInt = function (val) {
    return val ? Math.floor(val) : val;
  };

  $scope.open = function (index) {
    $scope.opened[index] = true;
  };

  $scope.datetimeValidCheck = function (id) {
    const checkValid = moment($scope.datetimedate[id]);

    if ($scope.values[id].value) {
      setTimeHMS(checkValid, $scope.values[id].value);
    }

    if (
      (!$scope.values[id].minValue || checkValid >= $scope.values[id].minValue) &&
      (!$scope.values[id].maxValue || checkValid <= $scope.values[id].maxValue)
    ) {
      return true;
    }
    return false;
  };

  $scope.updateTimeBounds = function (id) {
    $scope.datetimeBounds[id].min = $scope.returnTimeBound('min', id);
    $scope.datetimeBounds[id].max = $scope.returnTimeBound('max', id);
  };

  $scope.returnTimeBound = function (key, id) {
    switch (key) {
      case 'max':
        if (!$scope.datetimedate[id] || !$scope.values[id].maxValue) {
          return undefined;
        }

        if ($scope.datetimedate[id].toDateString() === $scope.values[id].maxValue.toDateString()) {
          const checkMax = moment($scope.values[id].value);

          if ($scope.values[id].maxValue) {
            setTimeHMS(checkMax, $scope.values[id].maxValue);
          }

          return checkMax.toDate();
        }
        return undefined;

      case 'min':
        if (!$scope.datetimedate[id] || !$scope.values[id].minValue) {
          return undefined;
        }

        if ($scope.datetimedate[id].toDateString() === $scope.values[id].minValue.toDateString()) {
          const checkMin = moment($scope.values[id].value);

          if ($scope.values[id].minValue) {
            setTimeHMS(checkMin, $scope.values[id].minValue);
          }

          return checkMin.toDate();
        }
        return undefined;
    }
  };

  $scope.checkAllDatetimes = function () {
    for (let i = 0; i < $scope.selectedTags.length; i++) {
      if ($scope.selectedTags[i].dataType === 'Datetime' && !$scope.selectedTags[i].freeform) {
        if (!$scope.datetimeValidCheck($scope.selectedTags[i].id)) {
          return false;
        }
      }
    }
    return true;
  };

  $scope.generateTooltip = (tag) => tagsService.generateTooltip(tag, vm.dateFormat);

  $scope.keyPressHandler = function (e, serialNum) {
    if (e.keyCode === 13 && serialNum) {
      if (!e) e = window.event;
      e.preventDefault();
      e.stopPropagation();
      $scope.checkInstallations(serialNum);
    }
  };

  $scope.checkInstallations = function (serialNum) {
    $scope.validatingSerialNumber = true;
    // check to see if the device has been activated
    installationsService
      .getInstallations(null, null, null, serialNum, null)
      .then(function (response) {
        const install = response.data;
        if (!!install && install.length > 0) {
          $scope.deviceSerialNumberError = gettextCatalog.getString(
            `Device ${serialNum} has already been activated.`,
          );
          $scope.validatingSerialNumber = false;
          $scope.showActivationForm = false;
        } else {
          $scope.deviceSerialNumberError = '';
        }
        return devicesService.getDevice(serialNum); // get the device model
      })
      .then(function (response) {
        const device = response.data;
        $scope.model.deviceSerialNumber = device.serialNumber;
        hardware = device.attrs.model;
        return packagesService.getAllPackages(); // get all packages
      })
      .then(function (response) {
        $scope.packages = [];
        $scope.modules = [];
        const { data = [] } = response;
        const compatiablePakg = data.filter(
          (pkg) => !pkg.inactive && pkg.hardware.includes(hardware),
        );
        compatiablePakg.forEach((pkg) => {
          pkg.isModule ? $scope.modules.push(pkg) : $scope.packages.push(pkg);
        });
      })
      .catch(function (error) {
        $scope.deviceSerialNumberError =
          error.status === 404
            ? gettextCatalog.getString(
                `Device ${serialNum} could not be found, Please enter a valid serial number`,
              )
            : gettextCatalog.getString('An error has occurred. Please contact your Administrator');
        $scope.validatingSerialNumber = false;
        $scope.showActivationForm = false;
      })
      .finally(function () {
        checkProductsForCompatibility();
        $scope.validatingSerialNumber = false;
        if ($scope.deviceSerialNumberError === '') {
          $scope.showActivationForm = true;
        }
      });
  };

  $scope.changeSelectedPackage = function (selectedPackage) {
    $scope.equipment.package = selectedPackage;
    $scope.userSelectedTemplatePackage = false;
  };

  $scope.addModuleToPackages = function (module) {
    $scope.selectedModules.push(module);
  };

  $scope.removeModuleFromPackages = function (module) {
    const idx = $scope.selectedModules.indexOf(module);
    $scope.selectedModules.splice(idx, 1);
  };

  // Submit the activation form if isValid
  $scope.submitActivationForm = function () {
    $scope.loading = true;
    let newInstallation = {};
    let sgResource = '';
    if ($scope.security.group) {
      sgResource = $scope.security.group.href;
    }

    const packagesIDs = [
      { id: $scope.equipment.package.id },
      ...$scope.selectedModules.map((item) => ({ id: item.id })),
    ];
    // newInstallation when no product
    newInstallation = {
      device: {
        serialNumber: $scope.model.deviceSerialNumber,
      },
      equipment: {
        name: $scope.model.equipmentName,
        attrs: {
          make: $scope.equipment.make,
          model: $scope.equipment.model,
          'model year': $scope.model.equipmentModelYear,
          vin: $scope.model.equipmentVin,
        },
      },
      packages: packagesIDs,
    };

    $scope.submitTags = [];
    for (let i = 0; i < $scope.selectedTags.length; i++) {
      let tagVal;
      switch ($scope.selectedTags[i].dataType) {
        case 'Text':
        case 'Hyperlink':
        case 'Integer':
        case 'Decimal':
          tagVal = $scope.values[$scope.selectedTags[i].id].value;
          break;
        case 'Date':
          tagVal = $filter('date')($scope.values[$scope.selectedTags[i].id].value, 'yyyy-MM-dd');
          break;
        case 'Datetime':
          if (typeof $scope.values[$scope.selectedTags[i].id].value === 'string') {
            tagVal = $scope.values[$scope.selectedTags[i].id].value;
          } else {
            const dateTime = moment($scope.datetimedate[$scope.selectedTags[i].id].toISOString());

            if ($scope.values[$scope.selectedTags[i].id].value) {
              setTimeHMS(dateTime, $scope.values[$scope.selectedTags[i].id].value);
            }
            tagVal = dateTime.toDate();
          }
          break;
      }
      newInstallation.equipment.attrs[$scope.selectedTags[i].key] = tagVal;
    }

    let rollbackThisActivationIdInCaseOfFailure = '';

    const handleError = function (response) {
      if (!response) {
        return $q.reject();
      }
      if (rollbackThisActivationIdInCaseOfFailure) {
        installationsService.deleteInstallation(rollbackThisActivationIdInCaseOfFailure).then(
          function () {
            rollbackThisActivationIdInCaseOfFailure = '';
            $scope.error = gettextCatalog.getString(
              'There was a problem transferring this device to the selected account. The installation was rolled back. Please report this issue to support.',
            );
          },
          function () {
            rollbackThisActivationIdInCaseOfFailure = '';
            $scope.error = gettextCatalog.getString(
              'There was a problem transferring this device to the selected account and the installation could not be rolled back. Please report this issue to support.',
            );
          },
        );
      } else if (response.status === 409) {
        $scope.error = gettextCatalog.getString('Name already in use.');
        beginWatchNameInput();
      } else {
        $scope.error = gettextCatalog.getString('Failure activating this device.');
      }
      $scope.loading = false;
      return $q.reject();
    };

    let beginWatchNameInput = function () {
      document.getElementById('equipmentName').addEventListener('input', function () {
        $scope.error = null;
      });
    };

    const postProcessInstallation = function (response) {
      const newInstallationId = response.data.href.match(/(\d+)$/)[1];
      if ($scope.model.transferKey && $scope.model.transferKey.id) {
        rollbackThisActivationIdInCaseOfFailure = newInstallationId;
        $scope.transferSuccessFlag = true;
        const resources = new Array();
        resources.push(response.data.href);
        return transfersService
          .transferResources($scope.model.transferKey.id, resources)
          .then(function () {
            $scope.transferSuccessFlag = false;
            $scope.loading = false;
            $scope.reset();
          })
          .then(clearForm);
      }
      rollbackThisActivationIdInCaseOfFailure = '';
      $scope.activationSuccessFlag = true;
      return installationsService.getInstallationById(newInstallationId).then(function (response) {
        $scope.$emit('installationCreated', {
          newInstallation: response.data,
        });
        $scope.installation = response.data;
        $scope.installationId = $scope.installation.id;
        $scope.deviceSerialNumber = $scope.installation.device.serialNumber;
        $scope.pkgId = $scope.installation.packages[0].id;
        $scope.equipId = $scope.installation.equipment.id;
        $scope.loading = false;

        $timeout(function () {
          $scope.activationSuccessFlag = false;
          $scope.next();
        }, 3000);
      });
    };

    dataLayer.push({
      event: gtmEvents.activationInstallationCreated,
      data: {
        newInstallation,
      },
    });

    installationsService
      .createInstallation(newInstallation, sgResource)
      .then(postProcessInstallation)
      .catch(handleError);
  }; // end submitActivationForm()

  $scope.showSelectProductsModal = function () {
    $scope.animationsEnabled = true;
    const modalInstance = $uibModal.open({
      animation: $scope.animationsEnabled,
      template: require('./templates-modal/templates.modal.html'),
      controller: 'DevicesActivationsSingleModalController',
      size: 'md',
      resolve: {
        products() {
          return $scope.availableProducts;
        },
      },
    });

    modalInstance.result.then(function (product) {
      if (product === 'cancel') {
      } else {
        $scope.isTemplateSelected = true;
        $scope.product = product;
        $scope.equipment.make = $scope.product.metadata.make;
        $scope.equipment.model = $scope.product.metadata.model;
        $scope.equipment.package = $scope.packages.find(
          (pkg) => pkg.id === $scope.product.package.id,
        );
        $scope.selectedPackage = $scope.equipment.package;
        $scope.selectedModules = $scope.product.modules || [];

        $scope.userSelectedTemplatePackage = true;
      }
    });
  };

  // Step 3 - Device Communication
  $scope.isDeviceConnected = function () {
    $scope.communicationActions = '';
    if ($scope.checkBox.isChecked === true) {
      $scope.disable.next = false;
      $scope.communicationActions = 'confirmed';
    }
  };

  $scope.getLastComm = function () {
    const serialNumber = $scope.deviceSerialNumber;
    devicesService
      .getDevice(serialNumber)
      .then(function (response) {
        const device = response.data;
        if (device.communicatedAt) {
          $scope.isConnected = true;
          $scope.loadingLastComm = false;
          $scope.reloadingLastComm = false;
          $scope.lastCommunication = device.communicatedAt;
        } else {
          $scope.loadingLastComm = false;
          $scope.reloadingLastComm = false;
          $scope.isConnected = false;
          $scope.lastCommunication = null;
        }
      })
      .catch(function () {
        $scope.error = gettextCatalog.getString(
          'An error occurred while attempting to communicate with the device.',
        );
        $scope.loadingLastComm = false;
        $scope.reloadingLastComm = false;
      });
  };

  // Step 4 = Device Connection Status
  $scope.reloadLastComm = function () {
    $scope.reloadingLastComm = true;
    $scope.getLastComm();
  };

  // Step 6 - GPS Location
  $scope.getGPSAction = function (gpsLocationModel) {
    $scope.gpsLocationAction = {};
    if (gpsLocationModel === 1) {
      $scope.gpsLocationAction = 'none';
    }
    if (gpsLocationModel === 2) {
      $scope.gpsLocationAction = 'correct';
    }
    if (gpsLocationModel === 3) {
      $scope.gpsLocationAction = 'incorrect';
    }
  };

  // Grab the equipmentId from the installation
  $scope.getInstallationLocation = function () {
    equipmentRepository
      .getSingleEquipment($scope.equipId)
      .then(function (response) {
        const equipmentData = response.data.data;
        if (equipmentData.attributes.coords) {
          vm.map.setView(
            [equipmentData.attributes.coords[1], equipmentData.attributes.coords[0]],
            19,
          );
          L.marker([equipmentData.attributes.coords[1], equipmentData.attributes.coords[0]], {
            icon: myIcon,
          }).addTo(vm.map);
          $scope.reloadingLocation = false;
        } else {
          $scope.reloadingLocation = false;
        }
      })
      .catch(function () {
        $scope.error = gettextCatalog.getString(
          'An error occurred while retrieving the location of the device.',
        );
        $scope.reloadingLocation = false;
      });
  };

  $scope.reloadLocation = function () {
    $scope.reloadingLocation = true;
    $scope.getInstallationLocation();
  };

  $scope.getLastReportedRunHours = function () {
    equipmentRepository
      .getEquipment($scope.installation.equipment.id, null, ['series'], null)
      .then(function (response) {
        const equipResponse = response.data;
        for (let i = 0; i < equipResponse.included.length; i++) {
          if (equipResponse.included[i].attributes.dataId === 'run_time') {
            $scope.runHours = equipResponse.included[i].attributes.last.v;
          }
        }
      })
      .catch(function () {
        $scope.error = gettextCatalog.getString(
          'An error occurred while trying to retrieve the last reported run hours.',
        );
      });
  };

  $scope.getRunHoursAction = function (runHoursModel) {
    $scope.runHoursAction = {};
    if (runHoursModel === 1) {
      $scope.runHoursAction = 'none';
    }
    if (runHoursModel === 2) {
      $scope.runHoursAction = 'correct';
    }
    if (runHoursModel === 3) {
      $scope.runHoursAction = 'incorrect';
    }
  };

  $scope.refreshDataPointValues = function () {
    $scope.refreshingSeriesData = true;
    $scope.getDataPointValues();
  };

  // Step 8 - Asset Data
  $scope.seriesDataFilter = function (item) {
    const filtered = false;
    if (item.tags != null && item.tags.length > 0) {
      for (let i = 0; i < item.tags.length; i++) {
        if (item.tags[i] === 'dtc') {
          return false;
        }
      }
    }
    if (item.last === null || item.last.v === null) {
      return false;
    }
    return !filtered;
  };

  $scope.getDataPointValues = function () {
    $scope.loadingSeries = true;
    $scope.seriesData = [];
    equipmentRepository
      .getEquipmentSeries($scope.equipId)
      .then(function (response) {
        if (!response) {
          $scope.noSeriesData = true;
          $scope.loadingSeries = false;
          $scope.refreshingSeriesData = false;
          $scope.equipmentSeries.lastcomm = gettextCatalog.getString('Not Available');
          $scope.equipmentSeries.isLoadingTableData = false;
        } else {
          // loop thru all series data
          for (let i = 0; i < response.data.length; i++) {
            // check for 'last' if it is missing skip it
            if (!response.data[i].last) {
              $scope.noSeriesData = true;
              continue; // skip rest of for loop.
            }
            // Clear all of the data points
            $scope.noSeriesData = false;
            for (let j = 0; j < $rootScope.currentUser.visibleDatapoints.length; j++) {
              if (response.data[i].tags[0] === $rootScope.currentUser.visibleDatapoints[j].id) {
                // Filter out DTC(Datapoint Faults)
                // They are always present, but should not be shown here. They should be part of alerts tab.
                if (response.data[i].tags.indexOf('dtc') > -1) {
                  if (+response.data[i].last.v) {
                    // convert to int with '+' and convert to boolean with a double '!'
                    // $scope.alarmCount = ++$scope.alarmCount;
                  }
                  break; // skip rest of for loop.
                }
                // determine UOM
                let uom = '';
                uom = response.data[i].attrs.uom;
                if (!uom) {
                  if (response.data[i].tags.indexOf('gps') > -1) uom = 'location';
                  else if (response.data[i].tags.indexOf('state') > -1) uom = 'boolean';
                  else if (response.data[i].tags.indexOf('speed') > -1) uom = 'km/h';
                }
                // determine filter to show nice values.
                if (response.data[i].tags.indexOf('numeric'))
                  $filter('number')(response.data[i].last.v, 1);

                if ($scope.wantedSeriesList.indexOf(response.data[i].title) > -1) {
                  // getting the wanted series datapoints
                  $scope.equipmentSeries.tabularDatapoints.push(response.data[i]);
                }
                const datapoint = response.data[i];
                if (datapoint.tags) {
                  const rootTag = datapoint.tags[0];
                  if (rootTag === 'battery_potential') {
                    datapoint.priority = 5;
                  } else if (rootTag === 'run_time') {
                    datapoint.priority = 10;
                    $scope.runHours = datapoint.last.v; // holding run hours
                  } else if (rootTag === 'fuel_level') {
                    datapoint.priority = 8;
                  } else if (rootTag === 'speed') {
                    datapoint.priority = 4;
                  } else {
                    datapoint.priority = 0;
                  }
                }
                $scope.seriesData.push(response.data[i]);
                break;
              }
            }
          }
        }
      })
      .catch(function () {
        const errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving asset details',
        );
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
        $scope.loadingSeries = false;
        return $q.reject();
      })
      .finally(function () {
        if ($scope.seriesData.length === 0) {
          $scope.noSeriesData = true;
        }
        $scope.loadingSeries = false;
        $scope.refreshingSeriesData = false;
      });
  };

  $scope.finish = function () {
    if ($scope.step === 'notes') {
      if ($scope.note.text !== '') {
        createNote();
      }
      logUserActions();
    }
    $state.go('devices2.detail', {
      installationId: $scope.installationId,
    });
  };

  $scope.reset = function () {
    logUserActions();
    if ($scope.step === 'notes') {
      if ($scope.note.text !== '') {
        createNote();
      }
    }
    $state.transitionTo($state.current, $stateParams, {
      reload: true,
      inherit: false,
      notify: true,
    });
  };
}
